(ns ui.view.counterparty-diligence.responder-form.model
  (:require
   [clojure.set :as set]
   [clojure.string :as string]
   [common.schema.entities.counterparty-diligence.templates.util :as template-util]
   [common.schema.entities.counterparty-diligence.templates.validation :as validation]
   [common.util :as cu]
   [potpuri.core :as p]))

(def sheet-view-key ::sheet-view)

(defn confirmation-modal-id
  [state-path]
  (->> state-path
       (mapv str)
       (string/join "-")
       (str "counterparty-diligence-confirmation-modal-")))

(def root?-path [:root?])

(defn root?-full-path
  [state-path]
  (into state-path root?-path))

(def view-mode-path [:view-mode])

(defn view-mode-full-path
  [state-path]
  (into state-path view-mode-path))

(def tenant-user-access-path [:tenant-user-access?])

(defn tenant-user-access-full-path
  [state-path]
  (into state-path tenant-user-access-path))

(def autosave-on-path [:autosave-on?])

(def date-format-path [:date-format])

(defn date-format-full-path
  [state-path]
  (into state-path date-format-path))

(defn autosave-on-full-path
  [state-path]
  (into state-path autosave-on-path))

(defn root?
  [db state-path]
  (get-in db (root?-full-path state-path)))

(defn autosave-on?
  [db state-path]
  (get-in db (autosave-on-full-path state-path)))

(def loading-path [:loading?])

(defn loading-full-path
  [state-path]
  (into state-path loading-path))

(def template-id-path [:template-id])

(defn template-id-full-path
  [state-path]
  (into state-path template-id-path))

(def template-path [:template])

(defn template-full-path
  [state-path]
  (into state-path template-path))

(def answers-path [:answers])

(defn answers-full-path
  [state-path]
  (into state-path answers-path))

(def initial-answers-path [:initial-answers])

(defn initial-answers-full-path
  [state-path]
  (into state-path initial-answers-path))

(def attachments-path [:attachments])

(defn attachments-full-path
  [state-path]
  (into state-path attachments-path))

(defn field-value-full-path
  [state-path field]
  (vec (concat state-path answers-path [field])))

(def edit-mode-path [:edit-mode?])

(defn edit-mode-full-path
  [state-path]
  (into state-path edit-mode-path))

(def process-id-path [:process-id])

(defn process-id-full-path
  [state-path]
  (into state-path process-id-path))

(def attachment-uploads-path [:attachment-uploads])

(defn attachment-uploads-full-path
  [state-path]
  (into state-path attachment-uploads-path))

(defn attachment-upload-full-path
  [state-path attachment-temp-id]
  (conj (attachment-uploads-full-path state-path) attachment-temp-id))

(def language-path [:language])

(defn language-full-path
  [state-path]
  (into state-path language-path))

(def saving-answers-path [:saving-answers?])

(defn saving-answers-full-path
  [state-path]
  (into state-path saving-answers-path))

(def submitting-path [:submitting?])

(defn submitting-full-path
  [state-path]
  (into state-path submitting-path))

(def submitted-path [:submitted?])

(defn submitted-full-path
  [state-path]
  (into state-path submitted-path))

(def pdf-doc-path [:pdf-doc])

(defn pdf-doc-full-path
  [state-path]
  (into state-path pdf-doc-path))

(def e-signature-required-path [:e-signature-required?])

(defn e-signature-required-full-path
  [state-path]
  (into state-path e-signature-required-path))

(defn unsaved-changes?
  [{:keys [answers initial-answers]}]
  (when (seq answers)
    (or (cu/empty-value? initial-answers)
        (not= answers initial-answers))))

(def signatories-path (into answers-path [:signatories]))

(defn signatories-full-path
  [state-path]
  (into state-path signatories-path))

(def form-available-path [:form-available])

(defn form-available-full-path
  [state-path]
  (into state-path form-available-path))

(def field-errors-path [:field-errors])

(defn field-errors-full-path
  [state-path]
  (into state-path field-errors-path))

(def visible-fields-path [:visible-fields])

(defn visible-fields-full-path
  [state-path]
  (into state-path visible-fields-path))

(def touched-fields-path [:touched-fields])

(defn touched-fields-full-path
  [state-path]
  (into state-path touched-fields-path))

(def sheet-submit-event-path [:sheet-submit-event])

(defn sheet-submit-event-full-path
  [state-path]
  (into state-path sheet-submit-event-path))

(def show-all-field-errors-path [:show-all-field-errors?])

(defn show-all-field-errors-full-path
  [state-path]
  (into state-path show-all-field-errors-path))

(def hide-all-field-errors-path [:hide-all-field-errors])

(defn hide-all-field-errors-full-path
  [state-path]
  (into state-path hide-all-field-errors-path))

(def confirmation-modal-state-path [:confirmation-modal-state])

(defn confirmation-modal-state-full-path
  [state-path]
  (into state-path confirmation-modal-state-path))

(defn update-field-errors
  [db {:keys [fields state-path] :as _args}]
  (let [answers (get-in db (answers-full-path state-path))
        template (get-in db (template-full-path state-path))
        fields (cond
                 (not fields)
                 (->> template
                      :template/schema
                      (mapv (fn [[field _field-config]]
                              field)))

                 (keyword? fields)
                 [fields]

                 :else fields)

        fields-with-linked-fields
        (->> fields
             (mapcat (fn [field]
                       (let [field-config (get-in template [:template/schema field])
                             linked-fields (:linked-fields field-config)]
                         (concat [field]
                                 (when (seq linked-fields)
                                   linked-fields)))))
             distinct
             vec)

        prev-field-errors (get-in db (field-errors-full-path state-path))
        attachments (get-in db (attachments-full-path state-path))
        e-signature-required? (get-in db (e-signature-required-full-path state-path))

        new-errors (->> fields-with-linked-fields
                        (mapv (fn [field]
                                [field
                                 (validation/validate-field
                                  {:field                 field
                                   :data                  answers
                                   :field-config          (get-in template [:template/schema field])
                                   :entity-lookup         (fn [eid]
                                                            (let [id (or (:db/id eid)
                                                                         eid)]
                                                              (get attachments id)))
                                   :validate-fields       validation/validate-fields
                                   :e-signature-required? e-signature-required?})]))
                        (into {}))

        updated-field-errors
        (->> (merge prev-field-errors
                    new-errors)
             (remove (fn [[_field errors]]
                       (cu/empty-value? errors)))
             (into {}))

        updated-field-errors (if (seq updated-field-errors)
                               updated-field-errors
                               nil)

        new-db (if updated-field-errors
                 (assoc-in db (field-errors-full-path state-path) updated-field-errors)
                 (p/dissoc-in db (field-errors-full-path state-path)))]
    new-db))

(defn update-field-visibilities
  [db {:keys [fields state-path]}]
  (let [template (get-in db (template-full-path state-path))
        answers (get-in db (answers-full-path state-path))
        e-signature-required? (get-in db (e-signature-required-full-path state-path))

        fields (cond
                 (not fields)
                 (->> template
                      :template/schema
                      (mapv (fn [[field _field-config]]
                              field)))

                 (keyword? fields)
                 [fields]

                 :else fields)

        fields-with-linked-fields
        (->> fields
             (mapcat (fn [field]
                       (let [field-config (get-in template [:template/schema field])
                             linked-fields (:linked-fields field-config)]
                         (concat [field]
                                 (when (seq linked-fields)
                                   linked-fields)))))
             distinct
             vec)

        results (->> fields-with-linked-fields
                     (mapv (fn [field]
                             (let [field-config (get-in template [:template/schema field])
                                   visible? (template-util/field-visible?
                                             {:field                 field
                                              :data                  answers
                                              :field-config          field-config
                                              :e-signature-required? e-signature-required?})]
                               {:field    field
                                :visible? visible?}))))

        fields-to-show (->> results
                            (filterv :visible?)
                            (mapv :field)
                            set)
        fields-to-hide (->> results
                            (remove :visible?)
                            (mapv :field)
                            set)
        prev-visible-fields (get-in db (visible-fields-full-path state-path) #{})

        new-visible-fields (->> prev-visible-fields
                                (remove #(contains? fields-to-hide %))
                                set
                                (set/union fields-to-show))]
    (assoc-in db (visible-fields-full-path state-path) new-visible-fields)))
